import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { KeyboardArrowDown as KeyboardArrowDown } from "@mui/icons-material";
import { Box, Button } from "@mui/material";
import React from "react";
import { PopoverOpenButton } from "../popover/PopoverOpenButton.js";
export const ButtonInputWithPopover = ({ label, counter, disabled, popoverWidth = "lg", content, overflowVisible, }) => {
    const [open, setOpen] = React.useState(false);
    return (_jsx(PopoverOpenButton, { onOpen: () => setOpen(true), onClose: () => setOpen(false), content: _jsx(Box, { sx: theme => ({
                width: `${theme.layout.filters.popoverWidth[popoverWidth]}px`,
                maxWidth: "100vw",
            }), children: content }), anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
        }, transformOrigin: {
            vertical: "top",
            horizontal: "left",
        }, PaperProps: {
            sx: {
                my: 0.5,
                ...(overflowVisible ? { overflow: "visible" } : undefined),
            },
        }, children: _jsxs(Button, { size: "extra-small", variant: "text", color: "primary", sx: { textTransform: "none" }, endIcon: _jsx(KeyboardArrowDown, { sx: {
                    transition: "transform 0.2s ease-out",
                    ...(open ? { transform: `rotate(-180deg)` } : undefined),
                } }), disabled: disabled, children: [label, counter ? ` (${counter})` : ""] }) }));
};
//# sourceMappingURL=ButtonInputWithPopover.js.map